import { render } from "./CheesyRewards.vue?vue&type=template&id=de2bd470"
import script from "./CheesyRewards.vue?vue&type=script&lang=js"
export * from "./CheesyRewards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__